import { Tag } from "antd";

import { PRODUCT_VISIBILITY_LABELS } from "./productVisibility";

interface IProductVisibilityBadge {
  isVisible: boolean | undefined;
}

/**
 * The visibility state of a product, on every screen that reviews one.
 *
 * Shared so the preview, the product detail view and the pending-update
 * approval screen cannot drift apart.
 */
export default function ProductVisibilityBadge({
  isVisible,
}: IProductVisibilityBadge) {
  if (isVisible === undefined) {
    return <Tag>{PRODUCT_VISIBILITY_LABELS.unknown}</Tag>;
  }

  return (
    <Tag color={isVisible ? "green" : "red"}>
      {isVisible
        ? PRODUCT_VISIBILITY_LABELS.visible
        : PRODUCT_VISIBILITY_LABELS.hidden}
    </Tag>
  );
}
